module.exports = __webpack_public_path__ + "static/img/tengxun.0851d36.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/client/logo/tengxun.jpg
// module id = snY6
// module chunks = 0